import i18n from "i18next";
import LanguageDetector, {
  DetectorOptions,
} from "i18next-browser-languagedetector";
import HttpBackend, { HttpBackendOptions } from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next)
  .use(HttpBackend)
  .use(LanguageDetector)
  .init<HttpBackendOptions & DetectorOptions>({
    debug: !import.meta.env.PROD,
    fallbackLng: "en",
    supportedLngs: ["ru", "en"],
    interpolation: {
      escapeValue: false,
    },
    detection: { order: ["localStorage", "navigator"] },
  });

export default i18n;
